import React, { useState } from 'react'
import {
  PAGINATION_DEFAULT,
  PerformanceEvaluationStatusConfig,
} from '../../utils/constants'
import { useGetAssignedPerformances } from '../../redux/human-resources/hook/performance'
import DataTable from '../datatable'
import AssessmentModal from './AssessmentModal'
import ViewEvaluation from './ViewEvaluation'

const Assessment = () => {
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: '',
  })

  const [assessmentModal, setAssessmentModal] = useState(false)
  const [viewEvaluation, setViewEvaluation] = useState(false)
  const [assessmentData, setAssessmentData] = useState()

  const { data: assignedPerformance } = useGetAssignedPerformances(
    pagination?.limit,
    pagination?.page,
    pagination?.search
  )

  const tableConfig = {
    headers: ['Employee Name', 'Deadline', 'Period Covered', 'Status'],
    keys: ['employeeName', 'deadline', 'period', 'status'],
    mobileHeader: {
      left: {
        title: 'Employee Name',
        key: 'employeeName',
      },
      right: {
        title: 'Period Covered',
        key: 'period',
      },
    },
  }

  const actionConfig = [
    {
      name: 'Evaluate',
      color: 'green',
      action: (id) => {
        let index = assignedPerformance.data.findIndex((item) => item.id === id)
        setAssessmentData(assignedPerformance.data?.[index])
        setAssessmentModal(true)
      },
    },
    {
      name: 'View',
      color: 'orange',
      action: (id) => {
        let index = assignedPerformance.data.findIndex((item) => item.id === id)
        setAssessmentData(assignedPerformance.data?.[index])
        setViewEvaluation(true)
      },
    },
  ]
  return (
    <>
      {assessmentModal ? (
        <AssessmentModal
          isOpen={assessmentModal}
          closeModal={() => setAssessmentModal(false)}
          assessmentData={assessmentData}
        />
      ) : null}

      {viewEvaluation ? (
        <ViewEvaluation
          isOpen={viewEvaluation}
          closeModal={() => setViewEvaluation(false)}
          assessmentData={assessmentData}
        />
      ) : null}
      <div>
        <hr className='divider mt-0 mb-2' />
        <DataTable
          data={assignedPerformance}
          tableConfig={tableConfig}
          actionConfig={actionConfig}
          computedActions={true}
          updatePagination={(data) => setPagination(data)}
          noCheck={true}
          statusConfig={PerformanceEvaluationStatusConfig}
        />
      </div>
    </>
  )
}

export default Assessment
